var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0137,-7.81597009e-14 C11.0337,-7.81597009e-14 11.9467,0.529 12.4527,1.415 L19.6387,13.979 C20.1417,14.858 20.1387,15.907 19.6297,16.784 C19.1207,17.662 18.2117,18.186 17.1987,18.186 L2.8157,18.186 C1.8017,18.186 0.8927,17.662 0.3837,16.784 C-0.1253,15.907 -0.1283,14.858 0.3747,13.979 L7.5747,1.413 C8.0807,0.528 8.9917,-7.81597009e-14 10.0127,-7.81597009e-14 L10.0137,-7.81597009e-14 Z M10.0127,1.5 C9.5367,1.5 9.1127,1.746 8.8747,2.159 L1.6767,14.724 C1.4427,15.134 1.4447,15.623 1.6817,16.032 C1.9187,16.441 2.3427,16.686 2.8157,16.686 L17.1987,16.686 C17.6707,16.686 18.0947,16.441 18.3317,16.032 C18.5697,15.623 18.5717,15.134 18.3357,14.724 L11.1507,2.159 C10.9137,1.746 10.4897,1.5 10.0127,1.5 Z M10.0059,12.499 C10.5589,12.499 11.0059,12.946 11.0059,13.499 C11.0059,14.052 10.5589,14.499 10.0059,14.499 C9.4529,14.499 9.0009,14.052 9.0009,13.499 C9.0009,12.946 9.4439,12.499 9.9959,12.499 L10.0059,12.499 Z M10.0039,6.564 C10.4179,6.564 10.7539,6.9 10.7539,7.314 L10.7539,10.414 C10.7539,10.828 10.4179,11.164 10.0039,11.164 C9.5899,11.164 9.2539,10.828 9.2539,10.414 L9.2539,7.314 C9.2539,6.9 9.5899,6.564 10.0039,6.564 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4da3e193e2784a74f219897cdcf90c50.svg";
export { ForwardRef as ReactComponent };